import { GETREQUESTOPTIONS, instance } from '../apiService';
import type { FacilityUser } from './facilityService';

export interface AddressInput {
    street?: string;
    number?: string;
    postalCode: number;
    city: string;
    country: string;
}

export interface UpdateFacilityInfoInput {
    name?: string;
    address?: AddressInput;
}

export const updateFacilityInfo = async (
    data: UpdateFacilityInfoInput
): Promise<void> => {
    await instance.post(
        '/api/department/onboarding/update-info',
        data,
        GETREQUESTOPTIONS()
    );
};

export const completeOnboarding = async (): Promise<{ success: boolean }> => {
    const res = await instance.post<{ success: boolean }>(
        '/api/department/onboarding/complete',
        {},
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const getMyDepartmentUsers = async (): Promise<FacilityUser[]> => {
    const res = await instance.get(
        '/api/department/users',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const updateUserRole = async (
    userId: string,
    actorId: string,
    departmentId?: string
): Promise<void> => {
    const url = departmentId
        ? `/api/department/admin/${departmentId}/users/update-role`
        : '/api/department/users/update-role';
    await instance.post(url, { userId, actorId }, GETREQUESTOPTIONS());
};

export interface RoleOption {
    _id: string;
    role: string;
    scope?: string;
    alternativeNames?: Record<string, string>;
}

export const getAvailableRoles = async (): Promise<RoleOption[]> => {
    const res = await instance.get(
        '/api/department/roles',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const sendBulkInvites = async (
    invites: Array<{ email: string; actorId?: string }>,
    departmentId?: string
): Promise<{ sent: number }> => {
    const url = departmentId
        ? `/api/invitation/admin/${departmentId}/create-bulk`
        : '/api/invitation/create-bulk';
    const res = await instance.post(url, { invites }, GETREQUESTOPTIONS());
    return res.data;
};

export const sendInviteReminder = async (
    invite: { id: string; email: string }
): Promise<void> => {
    await instance.post(
        '/api/invitation/send-reminders',
        {
            infos: [invite],
            title: 'Complete your NordInsight signup',
            news: 'Please complete your signup to join your department on NordInsight.',
        },
        GETREQUESTOPTIONS()
    );
};
